import { Header, NAV_IDS } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { About } from "../components/About";
import { Services } from "../components/Services";
import { Logistics } from "../components/Logistics";
import { Clients } from "../components/Clients";
import { News } from "../components/News";
import { Contact } from "../components/Contact";
import { Newsletter } from "../components/Newsletter";
import { Footer } from "../components/Footer";
import { SmoothScroll } from "../components/SmoothScroll";
import { WhatsAppFloat } from "../components/WhatsAppFloat";
import { MusicToggle } from "../components/MusicToggle";

export default function Home() {
  return (
    <div data-testid="home-page" className="relative">
      <SmoothScroll />
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Logistics />
        <Clients />
        <News />
        <Contact />
        <Newsletter />
      </main>
      <Footer />
      <WhatsAppFloat />
      <MusicToggle />
    </div>
  );
}
